'use client';

import { useEffect, useState } from 'react';

export type DateRange = { from: Date; to: Date };
const useScheduledContent = (dates: DateRange[]) => {
  const validateDates = (dates: DateRange[]) => {
    if (!Array.isArray(dates) || dates.length === 0) {
      throw new Error('Invalid dates array provided');
    }

    dates.forEach((range) => {
      if (!(range.from instanceof Date) || !(range.to instanceof Date)) {
        throw new Error('Invalid date range provided');
      }
      if (range.from > range.to) {
        throw new Error('Start date must be before end date');
      }
    });
  };

  const isDateInRange = () => {
    const date = new Date();
    validateDates(dates);
    const inrange = dates.some((range) => date > range.from && date < range.to);
    return inrange;
  };

  const dateIsInRange = isDateInRange();

  return { dateIsInRange };
};

export default useScheduledContent;
